export default __webpack_public_path__ + "static/media/priority_high_black_24dp.9d13a4d0.svg";